// extracted by mini-css-extract-plugin
module.exports = {"content":"step-1_content__2jXim","whatyouget":"step-1_whatyouget__2751h"};